export interface ProductCustomerDetails {
  id: string;
  customerId: string;
  customerKey: string;
  customerName: string;
  productId: string;
  productKey: string;
  productDescription: string;
  productType: string;
  default: boolean;
  defaultYesNo: boolean;
  partNo: string;
  currencyCode: string;
  currencySymbol: string;
  stdPrice: number;
  stdCutPrice: number;
  minimumOrderQuantity: number;
}
